export default __webpack_public_path__ + "static/media/slider-typography-03.82c1019a.png";